import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Datepicker.scss";

export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function Datepicker(props) {
  const {
    dateFormat = "dd-MM-yyyy",
    showMonthDropdown = true,
    showYearDropdown = true,
    yearDropdownItemNumber = 10,
    selected,
    onChange,
    customInput,
    disabled,
    className = "",
    minDate,
    maxDate,
    placeholderText = "Select date",
    ...rest
  } = props;

  const today = new Date();
  const defaultMinDate = new Date(today.getFullYear() - 10, 0, 1);
  const defaultMaxDate = new Date(today.getFullYear() + 10, 0, 1);

  return (
    <DatePicker
      dateFormat={dateFormat}
      showMonthDropdown={showMonthDropdown}
      showYearDropdown={showYearDropdown}
      yearDropdownItemNumber={yearDropdownItemNumber}
      dropdownMode="select"
      selected={selected}
      onChange={onChange}
      onChangeRaw={(e) => e?.preventDefault()}
      customInput={customInput}
      disabled={disabled}
      className={className}
      minDate={minDate ?? defaultMinDate}
      maxDate={maxDate ?? defaultMaxDate}
      placeholderText={placeholderText}
      {...rest}
    />
  );
}

export default Datepicker;
